export const supplierPerformanceData = [
  { metric: 'Quality', supplierA: 95, supplierB: 85, supplierC: 92 },
  { metric: 'On-Time', supplierA: 98, supplierB: 92, supplierC: 88 },
  { metric: 'Cost', supplierA: 80, supplierB: 88, supplierC: 95 },
  { metric: 'Service', supplierA: 90, supplierB: 94, supplierC: 85 },
  { metric: 'Innovation', supplierA: 85, supplierB: 80, supplierC: 90 },
]; 